import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import { locales } from '../../../../locales/en';
import IconViewers from '../../../Icons/Viewers';
import "./Popular.linaria.module.css!=!./Popular?./Popular.linaria.module.css?css=H4sIAAAAAAAAA22OzW7DIBCE732PSu2ByKSt41Apr4IwYEMMrA3rv1p996pxYymVjzM738weBHpeSU5NDtf+6/Aol2uf0FYzkRBQB2RSB9Tx8/vpFjQP2KYW4WwdiEXt0z/inDjFabSDW5RNrRMzq5ye7udh5hRSB8dhGa1Cw2iWPW+sKLu5ufMXZYfdDmoaA7bieH6fMe1YN9KLWNtASkAEz2i74VJoPXH60fhCdZfUirBIcBDZIOILIaVQtSYttL0T8XXbVH1fxBMvwhs9ljvWWlRBQDJqWxtkJTi14XlR65g4LWiWn+QaXj/8m13F794PCL0TI7EBAAA="
const rootStyles = "atm_fc_1h6ojuz atm_h_1h6ojuz atm_9s_1txwivl atm_vy_1osqo2v atm_9abqyk_1txwivl atm_1hkhoif_t94yts atm_caeex_15km8dq atm_1duu8r7_8n312b atm_168gers_181067c";
interface PopularBannerProps {
  viewersClassName?: LinariaClassName;
  viewersStyle?: CSSProperties;
  className?: LinariaClassName;
  style?: CSSProperties;
  hideIcon?: boolean;
  iconSize?: number;
  viewers: number;
  text?: string;
}
const PopularBanner = memo((props: PopularBannerProps) => {
  const {
    viewersClassName,
    text = 'in room',
    viewersStyle,
    className,
    iconSize,
    hideIcon,
    viewers,
    style
  } = props;
  return <div data-testid="Container__PopularBanner" className={cx(rootStyles, className)} style={style}>
            {!hideIcon && <div>
                    <IconViewers title={locales.modelTile.viewers} size={iconSize} />
                </div>}
            <span className={viewersClassName} style={viewersStyle}>
                {viewers}
            </span>
            {text}
        </div>;
});
export default PopularBanner;
export { PopularBanner };